import { httpCreate } from './http';

const http = httpCreate('/srv/excel');

export const excel = {
	getToken(params) {
		return http.get('/token', { params });
	},
};
